import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { useState as E, useEffect as L } from "react";
import { cn as i } from "./designsystem-ui-react47.js";
import c from "./designsystem-ui-react85.js";
import f from "./designsystem-ui-react86.js";
import F from "./designsystem-ui-react87.js";
function A(o) {
  return o >= 5 ? c : o >= 1.5 ? F : f;
}
function B({
  rating: o,
  isCompact: I = !1,
  maxRating: v = 5,
  amountOfRatings: p = 0,
  className: $ = "",
  inverted: s,
  interactive: h = !1,
  onRatingChange: S,
  oneTimeRating: m = !1,
  hasRated: b = !1
}) {
  const [k, y] = E(null), [P, w] = E(b);
  L(() => {
    w(b);
  }, [b]);
  const x = b || P, l = h && !(m && x), u = k !== null ? k : o, C = s ? "white" : "currentColor";
  if (I) {
    const r = A(u);
    return /* @__PURE__ */ a(
      "div",
      {
        className: i("flex items-center", s ? "text-ink-brand-inverted" : "text-ink-brand-default", $),
        children: [
          /* @__PURE__ */ e(r, { fill: C }),
          /* @__PURE__ */ a("div", { className: "ordinal flex items-center gap-x-1", children: [
            u ? /* @__PURE__ */ e("span", { className: i("inline-block", s ? "text-ink-brand-inverted" : "text-ink-brand-default"), children: u.toFixed(1) }) : null,
            p ? /* @__PURE__ */ a("span", { className: i("inline-block text-xs", s ? "text-ink-brand-inverted" : "text-ink-subtle"), children: [
              "(",
              p,
              ")"
            ] }) : null
          ] })
        ]
      }
    );
  }
  const g = (r) => {
    l && y(r + 1);
  }, j = () => {
    l && y(null);
  }, M = (r) => {
    if (l && S) {
      const n = r + 1;
      S(n), m && w(!0);
    }
  }, D = (r) => {
    const t = { ...h ? { height: 30, width: 30 } : {}, fill: C };
    if (l && k !== null)
      return r < k ? /* @__PURE__ */ e(c, { ...t }) : /* @__PURE__ */ e(f, { ...t });
    if (o === 5)
      return r < 5 ? /* @__PURE__ */ e(c, { ...t }) : /* @__PURE__ */ e(f, { ...t });
    const d = Math.floor(o), N = o - d;
    return N >= 0.1 && N <= 0.5 ? r < d ? /* @__PURE__ */ e(c, { ...t }) : r === d ? /* @__PURE__ */ e(F, { ...t }) : /* @__PURE__ */ e(f, { ...t }) : N > 0.5 ? r < d + 1 ? /* @__PURE__ */ e(c, { ...t }) : /* @__PURE__ */ e(f, { ...t }) : r < d ? /* @__PURE__ */ e(c, { ...t }) : /* @__PURE__ */ e(f, { ...t });
  };
  return /* @__PURE__ */ a("div", { className: "flex items-center gap-1", children: [
    /* @__PURE__ */ e(
      "div",
      {
        className: i(
          "flex",
          h ? "cursor-pointer gap-3" : "gap-1",
          s ? "text-ink-brand-inverted" : "text-ink-brand-default",
          m && x ? "opacity-90" : ""
        ),
        onMouseLeave: j,
        children: Array.from({ length: v }, (r, n) => /* @__PURE__ */ e(
          "span",
          {
            "aria-label": l ? `Rate ${n + 1} out of ${v}` : void 0,
            className: i("text-yellow-500", m && x ? "cursor-default" : ""),
            onClick: () => {
              l && M(n);
            },
            onKeyDown: (t) => {
              l && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), M(n));
            },
            onMouseEnter: () => {
              l && g(n);
            },
            role: l ? "button" : void 0,
            tabIndex: l ? 0 : void 0,
            children: D(n)
          },
          `star-${n}-${v}`
        ))
      }
    ),
    !h && /* @__PURE__ */ a("div", { className: "ordinal flex items-center gap-x-1", children: [
      u ? /* @__PURE__ */ e("span", { className: i("inline-block", s ? "text-ink-brand-inverted" : "text-ink-brand-default"), children: u.toFixed(1) }) : null,
      p ? /* @__PURE__ */ a("span", { className: i("inline-block", s ? "text-ink-brand-inverted" : "text-ink-subtle"), children: [
        "(",
        p,
        ")"
      ] }) : null
    ] })
  ] });
}
export {
  B as Rating
};
